import Axios from '../utils/axios-utils';

// create Service Config
export const createServiceConfig = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/services/confs`, {
            vehicleId: data.vehicleId,
            serviceType: data.serviceType,
            triggerType: data.triggerType,
            start: data.start,
            period: data.period,
            note: data.note,
            attributes: data.attributes,
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create Service Config error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create Service Config failed" }
        };
    }
};

// get all Service Configs
export const getAllServiceConfig = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/services/confs`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Service Configs error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Service Configs failed" }
        };
    }
};

// delete service config
export const deleteServiceConfig = async (accountId, serviceConfId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/services/confs/${serviceConfId}`);
        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Delete service config error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Delete service config failed" },
            status: error.response?.status || 500
        };
    }
};

// update service config
export const updateServiceConfig = async (accountId, serviceConfId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/services/confs/${serviceConfId}`, data);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update service config error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update service config failed" }
        };
    }
};

// update service config status
export const updateServiceConfigStatus = async (accountId, serviceConfId, status) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/services/confs/${serviceConfId}/status`, {
            status,
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update service config Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update service config Status failed" }
        };
    }
};

// get all Service Config statuses
export const getAllServiceConfigStatuses = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/services/confs/statuses`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Service Config statuses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Service Config statuses failed" }
        };
    }
};

// get all Service Configs types
export const getAllServiceConfigTypes = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/services/confs/types`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Service Configs types error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Service Configs types failed" }
        };
    }
};